
import {
  defineComponent,
} from 'vue';

export default defineComponent({
  name: 'Loading',
  components: {},
  setup() {
    return {};
  },
});
